var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{staticClass:"van-nav-bar",attrs:{"title":_vm.goback_title,"left-text":"返回","left-arrow":"","right-text":"刷新"},on:{"click-left":_vm.onClickLeft,"click-right":_vm.onClickRight}})
}
var staticRenderFns = []

export { render, staticRenderFns }